import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./common";
import { Button } from "./ui/button";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-slate-100 bg-white/80 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 sm:py-4">
        <Link to="/" aria-label="Servantage home"><Logo /></Link>
        <nav className="flex items-center gap-1.5 sm:gap-2">
          <Link to="/insights" className="px-2 text-sm font-semibold text-slate-600 hover:text-slate-900 sm:px-3" data-testid="nav-insights">Insights</Link>
          <Link to="/login"><Button variant="ghost" size="sm" className="sm:h-10 sm:px-4" data-testid="nav-login">Sign in</Button></Link>
          <Link to="/register"><Button size="sm" data-testid="nav-get-started" className="bg-[#4338CA] hover:bg-[#3730A3] sm:h-10 sm:px-4">Start free</Button></Link>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="border-t border-slate-200 py-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 text-center text-sm text-slate-400 sm:flex-row sm:px-6 sm:text-left">
        <Logo />
        <span>© {new Date().getFullYear()} Servantage · <Link to="/insights" className="hover:text-slate-600" data-testid="footer-insights">Insights</Link> · <Link to="/privacy" className="hover:text-slate-600">Privacy</Link></span>
        <span className="text-xs">Statistics: Qualtrics XM Institute, Bain &amp; Company, PwC</span>
      </div>
    </footer>
  );
}
